/**
 * Created by zato93 on 10/27/17.
 */
import Vue from 'vue';
import Vuex from "vuex";
Vue.use(Vuex);
import posts from "./store/posts.js";
import videos from "./store/videos.js";
import albums from "./store/albums.js";

export default new Vuex.Store({
    modules: { posts, videos, albums },
    state: {
        lang: localStorage.lang ? localStorage.lang : 'ru',
        translates: {},
        translates_loaded: false,
        backgrounds: {}
    },
    mutations: {
        setLang(state, lang) {
            state.lang = lang;
        }
    },
    getters: {
        all_loaded(state) {
            return state.translates_loaded && state.posts.loaded
        },
        translates(state) {
            return Object.keys(state.translates).reduce((ns, tr_code) => {
                ns[tr_code] = state.translates[tr_code][state.lang];
                // if (state.lang === 'kz') {
                //     ns[tr_code] = ns[tr_code].kzToLatin();
                // }
                return ns;
            }, {});
        }
    },
    actions: {
        loadTranslates({ state }) {
            Vue.http.get("content/translates").then((res) => {
                state.translates = res.body.translates.reduce((ns, tr) => {
                    ns[tr.code] = tr;
                    return ns;
                }, {});
                state.translates_loaded = true;
            });
        },
        loadBackgrounds({  state }) {
            Vue.http.get("content/backgrounds").then((res) => {
                state.backgrounds = res.body.backgrounds.reduce((ns, bkg) => {
                    ns[bkg.path] = bkg.image.toHttps();
                    return ns;
                }, {});
            });
        }
    }
});